module.exports = __webpack_public_path__ + "static/img/background4.b8d0f99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background4.jpg
// module id = uXME
// module chunks = 0